/**
 * MyPalette Component - Created by david on 28/02/18.
 */
import * as React from 'react'
import { List } from 'immutable'
import Message from 'antd/lib/message'
import Modal from 'antd/lib/modal'

import PaletteCard from '../../PaletteCard'
import messages from './messages'

import { Palette, MyPaletteDesignCenterModals } from '../../../types/common'
import {
  Container,
  Button,
  Input,
  Padding,
  ListContainer,
  InputWrapper,
  ModalMessage
} from './styledComponents'
import ModalTitle from '../../ModalTitle'
import ModalFooter from '../../ModalFooter'
import message from 'antd/lib/message'
import { colorNames } from '../../../constants'

interface Props {
  palettes: Palette[]
  paletteName: string
  paletteSelected: string
  colors: string[]
  myPaletteModals: MyPaletteDesignCenterModals
  showContent?: boolean
  onSelectPalette: (colors: string[], name?: string) => void
  onSetPalettes: (palettes: Palette[]) => void
  onChangePaletteName: (name: string) => void
  formatMessage: (messageDescriptor: any, values?: {}) => string
  openPaletteModalAction: (key: string, open: boolean, value?: number) => void
}

class MyPalette extends React.PureComponent<Props> {
  componentWillMount() {
    const { onSetPalettes } = this.props
    let palettes: Palette[] = []
    if (typeof window !== 'undefined') {
      const palettesJson = localStorage.getItem('palettes')
      if (palettesJson) {
        palettes = JSON.parse(palettesJson)
      }
    }
    onSetPalettes(palettes)
  }

  updatePaletteName = (event: React.FormEvent<HTMLInputElement>) => {
    const { onChangePaletteName } = this.props
    const {
      currentTarget: { value }
    } = event
    onChangePaletteName(value)
  }

  onSavePalette = () => {
    const {
      onSetPalettes,
      paletteName,
      onChangePaletteName,
      colors = [],
      formatMessage,
      showContent = true
    } = this.props
    if (!paletteName || !showContent) {
      return
    }
    const palettesTest: Palette = {
      name: paletteName,
      colors
    }
    if (typeof window !== 'undefined') {
      const palettesJson = localStorage.getItem('palettes')
      let myPalettes: Palette[] = []
      if (palettesJson) {
        myPalettes = JSON.parse(palettesJson)
        if (myPalettes && myPalettes.length > 0) {
          const nameToVerify = paletteName ? paletteName.trim().toLowerCase() : ''
          for (const item of myPalettes) {
            if (item.name && item.name.toLowerCase().trim() === nameToVerify) {
              message.error('Palette name already exists! please use a different one', 8)
              return
            }
            if (item.colors && item.colors.length > 0 &&
              item.colors[0] && item.colors[0] === colors[0] &&
              item.colors[1] && item.colors[1] === colors[1] &&
              item.colors[2] && item.colors[2] === colors[2] &&
              item.colors[3] && item.colors[3] === colors[3] &&
              item.colors[4] && item.colors[4] === colors[4]
            ) {
              message.error('Palette already saved!', 8)
              return
            }
          }
        }
        myPalettes.unshift(palettesTest)
      } else {
        myPalettes.unshift(palettesTest)
      }
      localStorage.setItem('palettes', JSON.stringify(myPalettes))
      onSetPalettes(myPalettes)
      onChangePaletteName('')
      Message.success(formatMessage(messages.paletteSaved))
    }
  }

  onDeletePalette = () => {
    const {
      onSetPalettes,
      openPaletteModalAction,
      myPaletteModals: { idPaletteToExecuteAction }
    } = this.props
    if (typeof window !== 'undefined') {
      const palettesJson = localStorage.getItem('palettes')
      if (palettesJson) {
        const myPalettes = JSON.parse(palettesJson)
        const listOfPalettes = List.of(...myPalettes)
        const updatedList = listOfPalettes.remove(idPaletteToExecuteAction)
        const updatedPalettes = updatedList.toJS()
        localStorage.setItem('palettes', JSON.stringify(updatedPalettes))
        onSetPalettes(updatedPalettes)
      }
      openPaletteModalAction('delete', false)
    }
  }

  handleOnSelectPalette = () => {
    const {
      colors: colorsArray,
      palettes,
      onSelectPalette,
      myPaletteModals: { idPaletteToExecuteAction },
      openPaletteModalAction
    } = this.props
    const paletteName = palettes[idPaletteToExecuteAction] ? palettes[idPaletteToExecuteAction].name : []
    const colorsSelected = palettes[idPaletteToExecuteAction] ? palettes[idPaletteToExecuteAction].colors : []
    const colors = [...colorsSelected]
    if (colors.length > colorsArray.length) {
      colors.length = colorsArray.length
    } else if (colorsArray.length > colors.length) {
      colors.push(...Array(colorsArray.length - colors.length).fill('#FFFFFF'))
    }
    onSelectPalette(colors, paletteName)
    openPaletteModalAction('apply', false)
  }

  onCancelDeletePalette = () => {
    const { openPaletteModalAction } = this.props
    openPaletteModalAction('delete', false)
  }

  handleOnShowDeletePaletteModal = (index: number) => {
    const { openPaletteModalAction } = this.props
    openPaletteModalAction('delete', true, index)
  }

  onCancelAppyPalette = () => {
    const { openPaletteModalAction } = this.props
    openPaletteModalAction('apply', false)
  }

  handleOnShowApplyPaletteModal = (index: number) => {
    const { openPaletteModalAction } = this.props
    openPaletteModalAction('apply', true, index)
  }

  render() {
    const {
      palettes,
      paletteName,
      paletteSelected,
      formatMessage,
      myPaletteModals: {
        openDeletePaletteModal,
        openApplyPaletteModal,
        idPaletteToExecuteAction
      }
    } = this.props
    const paletteList = palettes.map(({ name, colors }, id) => (
      <PaletteCard
        key={id}
        colorNames={colorNames}
        onClickDelete={this.handleOnShowDeletePaletteModal}
        onSelectPalette={this.handleOnShowApplyPaletteModal}
        isApplied={paletteSelected === name}
        {...{ id, name, colors, formatMessage }}
      />
    ))
    const paletteNameToApply =
      idPaletteToExecuteAction !== -1
        ? palettes[idPaletteToExecuteAction].name
        : ''
    return (
      <Container>
        <Padding>
          <InputWrapper disabled={!paletteName}>
            <Input
              id="paletteNameInput"
              value={paletteName}
              onChange={this.updatePaletteName}
              maxLength={20}
              placeholder={formatMessage(messages.paletteNamePlaceHolder)}
              addonAfter={
                <Button disabled={!paletteName} onClick={this.onSavePalette}>
                  Save
                </Button>
              }
            />
          </InputWrapper>
        </Padding>
        <ListContainer>{paletteList}</ListContainer>
        <Modal
          visible={openDeletePaletteModal}
          title={<ModalTitle title={formatMessage(messages.modalTitle)} />}
          footer={
            <ModalFooter
              onOk={this.onDeletePalette}
              onCancel={this.onCancelDeletePalette}
              {...{ formatMessage }}
            />
          }
          closable={false}
          maskClosable={false}
          destroyOnClose={true}
        >
          <ModalMessage>
            {formatMessage(messages.deletePaletteMessage)}
          </ModalMessage>
        </Modal>
        <Modal
          visible={openApplyPaletteModal}
          title={
            <ModalTitle
              title={formatMessage(messages.applyPalette, {
                paletteNameToApply
              })}
            />
          }
          footer={
            <ModalFooter
              onOk={this.handleOnSelectPalette}
              onCancel={this.onCancelAppyPalette}
              {...{ formatMessage }}
            />
          }
          closable={false}
          maskClosable={false}
          destroyOnClose={true}
        >
          <ModalMessage>
            {formatMessage(messages.applyPaletteMessage)}
          </ModalMessage>
        </Modal>
      </Container>
    )
  }
}

export default MyPalette



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/MyPalette/index.tsx